{
  "INBOX_MGMT": {
    "HEADER": "Inboxes",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Reconnect",
      "FACEBOOK": "The connection to Facebook expired or was revoked. Messages sent to the page do not reach this inbox, and replies can fail. A person who manages the Facebook page must click Reconnect and sign in to Facebook.",
      "INSTAGRAM": "The connection to Instagram expired or was revoked. Messages sent to the account do not reach this inbox, and replies can fail. Click Reconnect and sign in to the same Instagram account. A different account creates a new inbox.",
      "GOOGLE": "The connection to Google expired or was revoked. New emails do not reach this inbox, and replies can fail. Click Reconnect and sign in to Google as {email}.",
      "MICROSOFT": "The connection to Microsoft expired or was revoked. New emails do not reach this inbox, and replies can fail. Click Reconnect and sign in to Microsoft as {email}.",
      "ALLEGRO": "The connection to Allegro expired or was revoked. Messages from buyers do not reach this inbox, and replies can fail. Click Reconnect and sign in to Allegro as the seller {seller}. A different seller account creates a new inbox.",
      "IMAP_LOGIN": "The mail server rejects the IMAP login {login}. New emails do not reach this inbox. Check the IMAP login and password on the {tab} tab and save them. We keep trying to sign in, and the inbox recovers as soon as the login works.",
      "WHATSAPP": "The connection to WhatsApp expired or was revoked. Attachments from customers do not reach this inbox, and replies can fail. Click Reconnect, sign in to Facebook and select the number {phone} again."
    },
    "LIST": {
      "404": "There are no inboxes attached to this account.",
      "RECONNECT_REQUIRED": "Reconnect required"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Choose Channel",
        "BODY": "Choose the provider you want to integrate with chat."
      },
      "INBOX": {
        "TITLE": "Create Inbox",
        "BODY": "Authenticate your account and create an inbox."
      },
      "AGENT": {
        "TITLE": "Add Agents",
        "BODY": "Add agents to the created inbox."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "You are all set to go!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Inbox Name",
        "PLACEHOLDER": "Enter your inbox name (eg: Acme Inc)",
        "ERROR": "Please enter a valid inbox name"
      },
      "WEBSITE_NAME": {
        "LABEL": "Website Name",
        "PLACEHOLDER": "Enter your website name (eg: Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Internal Name",
        "PLACEHOLDER": "Name the inbox as shown in this dashboard",
        "ERROR": "Please enter a unique internal name"
      },
      "FB": {
        "HELP": "PS: By signing in, we only get access to your Page's messages. Your private messages can never be accessed by us.",
        "CHOOSE_PAGE": "Choose Page",
        "CHOOSE_PLACEHOLDER": "Select a page from the list",
        "INBOX_NAME": "Inbox Name",
        "ADD_NAME": "Add a name for your inbox",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Pick a value",
        "CREATE_INBOX": "Create Inbox"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continue with Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Connect your Instagram Profile",
        "HELP": "To add your Instagram profile as a channel, you need to authenticate your Instagram Profile by clicking on 'Continue with Instagram' ",
        "ERROR_MESSAGE": "There was an error connecting to Instagram, please try again",
        "ERROR_AUTH": "There was an error connecting to Instagram, please try again",
        "NEW_INBOX_SUGGESTION": "This Instagram account was previously linked to a different inbox and has now been migrated here. All new messages will appear here. The old inbox will no longer be able to send or receive messages for this account.",
        "DUPLICATE_INBOX_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. You won’t be able to send/receive Instagram messages from this inbox anymore."
      },
      "TWITTER": {
        "HELP": "To add your Twitter profile as a channel, you need to authenticate your Twitter Profile by clicking on 'Sign in with Twitter' ",
        "ERROR_MESSAGE": "There was an error connecting to Twitter, please try again",
        "TWEETS": {
          "ENABLE": "Create conversations from mentioned Tweets"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Website channel",
        "DESC": "Create a channel for your website and start supporting your customers via our website widget.",
        "LOADING_MESSAGE": "Creating Website Support Channel",
        "CHANNEL_AVATAR": {
          "LABEL": "Channel Avatar"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Please enter a valid URL"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Website Domain",
          "PLACEHOLDER": "Enter your website domain (eg: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Welcome Heading",
          "PLACEHOLDER": "Hi there !"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Welcome Tagline",
          "PLACEHOLDER": "We make it simple to connect with us. Ask us anything, or share your feedback."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Channel greeting message",
          "PLACEHOLDER": "Acme Inc typically replies in a few hours."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Enable channel greeting",
          "HELP_TEXT": "Auto-send greeting messages when customers start a conversation and send their first message.",
          "ENABLED": "Enabled",
          "DISABLED": "Disabled"
        },
        "REPLY_TIME": {
          "TITLE": "Set Reply time",
          "IN_A_FEW_MINUTES": "In a few minutes",
          "IN_A_FEW_HOURS": "In a few hours",
          "IN_A_DAY": "In a day",
          "HELP_TEXT": "This reply time will be displayed on the live chat widget"
        },
        "WIDGET_COLOR": {
          "LABEL": "Widget Color",
          "PLACEHOLDER": "Update the widget color used in widget"
        },
        "SUBMIT_BUTTON": "Create inbox",
        "API": {
          "ERROR_MESSAGE": "We were not able to create a website channel, please try again"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp Channel",
        "DESC": "Integrate Twilio and start supporting your customers via SMS or WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Account SID",
          "PLACEHOLDER": "Please enter your Twilio Account SID",
          "ERROR": "This field is required"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "This field is required"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "This field is required"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Messaging Service SID",
          "PLACEHOLDER": "Please enter your Twilio Messaging Service SID",
          "ERROR": "This field is required",
          "USE_MESSAGING_SERVICE": "Use a Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Channel Type",
          "ERROR": "Please select your Channel Type"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth Token",
          "PLACEHOLDER": "Please enter your Twilio Auth Token",
          "ERROR": "This field is required"
        },
        "CHANNEL_NAME": {
          "LABEL": "Inbox Name",
          "PLACEHOLDER": "Please enter a inbox name",
          "ERROR": "This field is required"
        },
        "PHONE_NUMBER": {
          "LABEL": "Phone Number",
          "PLACEHOLDER": "Please enter the phone number from which message will be sent.",
          "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "You have to configure the message callback URL in Twilio with the URL mentioned here."
        },
        "SUBMIT_BUTTON": "Create Twilio Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to authenticate Twilio credentials, please try again"
        }
      },
      "SMS": {
        "TITLE": "SMS Channel",
        "DESC": "Start supporting your customers via SMS.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the SMS channel"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Account ID",
            "PLACEHOLDER": "Please enter your Bandwidth Account ID",
            "ERROR": "This field is required"
          },
          "API_KEY": {
            "LABEL": "API Key",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "This field is required"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "This field is required"
          },
          "APPLICATION_ID": {
            "LABEL": "Application ID",
            "PLACEHOLDER": "Please enter your Bandwidth Application ID",
            "ERROR": "This field is required"
          },
          "INBOX_NAME": {
            "LABEL": "Inbox Name",
            "PLACEHOLDER": "Please enter a inbox name",
            "ERROR": "This field is required"
          },
          "PHONE_NUMBER": {
            "LABEL": "Phone number",
            "PLACEHOLDER": "Please enter the phone number from which message will be sent.",
            "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
          },
          "SUBMIT_BUTTON": "Create Bandwidth Channel",
          "API": {
            "ERROR_MESSAGE": "We were not able to authenticate Bandwidth credentials, please try again"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "You have to configure the message callback URL in Bandwidth with the URL mentioned here."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Inbox Name",
            "PLACEHOLDER": "Please enter an inbox name",
            "ERROR": "This field is required"
          },
          "PHONE_NUMBER": {
            "LABEL": "Phone number",
            "PLACEHOLDER": "Please enter the phone number from which messages will be sent.",
            "ERROR": "Please provide a valid phone number that starts with a `+` sign."
          },
          "SUBMIT_BUTTON": "Create SMS Brana Channel",
          "API": {
            "ERROR_MESSAGE": "We were not able to create the SMS Brana channel"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Inbox Name",
            "PLACEHOLDER": "Please enter an inbox name",
            "ERROR": "This field is required"
          },
          "PHONE_NUMBER": {
            "LABEL": "Phone number",
            "PLACEHOLDER": "Please enter the phone number from which messages will be sent.",
            "ERROR": "Please provide a valid phone number that starts with a `+` sign."
          },
          "SUBMIT_BUTTON": "Create DIDWW Channel",
          "API": {
            "ERROR_MESSAGE": "We were not able to create the DIDWW channel"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "You have to configure the webhook URL and the verification token in the Facebook Developer portal with the values shown below.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Verification Token"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Quick Setup with Meta",
          "DESC": "You will be redirected to Meta to log into your WhatsApp Business account. Having admin access will help make the setup smooth and easy.",
          "BENEFITS": {
            "EASY_SETUP": "No manual configuration required",
            "SECURE_AUTH": "Secure OAuth based authentication",
            "AUTO_CONFIG": "Automatic webhook and phone number configuration"
          },
          "SUBMIT_BUTTON": "Connect with WhatsApp Business",
          "AUTH_PROCESSING": "Authenticating with Meta",
          "WAITING_FOR_BUSINESS_INFO": "Please complete business setup in the Meta window...",
          "PROCESSING": "Setting up your WhatsApp Business Account",
          "CANCELLED": "WhatsApp Signup was cancelled",
          "WAITING_FOR_AUTH": "Waiting for authentication...",
          "INVALID_BUSINESS_DATA": "Invalid business data received from Facebook. Please try again.",
          "SIGNUP_ERROR": "Signup error occurred",
          "SDK_LOAD_ERROR": "Could not load the Facebook SDK. Please try again.",
          "AUTH_NOT_COMPLETED": "Authentication not completed. Please restart the process.",
          "SUCCESS_FALLBACK": "WhatsApp Business Account has been successfully configured",
          "RECONNECTED": "WhatsApp channel reconnected successfully"
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the WhatsApp channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API Channel",
        "DESC": "Integrate with API channel and start supporting your customers.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Create API Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the api channel"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce channel",
        "DESC": "Integrate with Salesforce channel and start supporting your customers.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "API_BASE_URL": {
          "LABEL": "Salesforce API URL",
          "SUBTITLE": "Configure the base URL for your Salesforce instance.",
          "PLACEHOLDER": "URL Salesforce API",
          "ERROR": "This field is required"
        },
        "KEY_ID": {
          "LABEL": "Key ID",
          "SUBTITLE": "Key ID for your Salesforce channel.",
          "PLACEHOLDER": "KEY ID",
          "ERROR": "This field is required"
        },
        "SECRET": {
          "LABEL": "Secret",
          "SUBTITLE": "Secret for your Salesforce channel.",
          "PLACEHOLDER": "*****",
          "ERROR": "This field is required"
        },
        "SUBMIT_BUTTON": "Create Salesforce Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the Salesforce channel"
        },
        "API_CALLBACK": {
          "TITLE": "Webhook URL",
          "SUBTITLE": "You have to configure the webhook URL in Salesforce with the URL mentioned here."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer Token",
          "SUBTITLE": "Use this bearer token for authentication when configuring the webhook in Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Override Email Sender",
          "SUBTITLE": "If set, this email address will be used as the sender for all outgoing emails instead of the conversation's source email.",
          "PLACEHOLDER": "e.g. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Allegro channel",
        "DESC": "Connect an Allegro seller account and answer its message center from Contact Center.",
        "CHANNEL_NAME": {
          "LABEL": "Inbox name",
          "SUBTITLE": "The name agents see for this inbox.",
          "PLACEHOLDER": "Enter an inbox name",
          "ERROR": "This field is required"
        },
        "SUBMIT_BUTTON": "Sign in with Allegro",
        "API": {
          "ERROR_MESSAGE": "There was an error connecting to Allegro, please try again"
        },
        "SELLER_LOGIN": {
          "TITLE": "Allegro login",
          "SUBTITLE": "The seller account this inbox reads and answers messages for."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kaufland channel",
        "DESC": "Answer the ticket messages buyers send you on the Kaufland marketplace.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "The 32 character Client Key from the API settings page of your Kaufland seller account.",
          "PLACEHOLDER": "32 character key",
          "ERROR": "Enter the 32 character Client Key"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "The 64 character Secret Key that belongs to the Client Key. Kaufland shows it once, and it is never sent back to this page.",
          "PLACEHOLDER": "64 character key",
          "ERROR": "Enter the 64 character Secret Key"
        },
        "SUBMIT_BUTTON": "Create Kaufland Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the Kaufland channel"
        },
        "DISCONNECTED": {
          "TITLE": "Disconnected",
          "MESSAGE": "Kaufland rejected these API keys. Enter the client key and secret key again to reconnect this inbox."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Email Channel",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "EMAIL": {
          "LABEL": "Email",
          "SUBTITLE": "Provide the email address where your customers send support requests.",
          "PLACEHOLDER": "Email"
        },
        "SUBMIT_BUTTON": "Create Email Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the email channel"
        },
        "FINISH_MESSAGE": "Start forwarding your emails to the following email address."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE Channel",
        "DESC": "Integrate with LINE channel and start supporting your customers.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE Channel ID",
          "PLACEHOLDER": "LINE Channel ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Channel Secret",
          "PLACEHOLDER": "LINE Channel Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Channel Token",
          "PLACEHOLDER": "LINE Channel Token"
        },
        "SUBMIT_BUTTON": "Create LINE Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the LINE channel"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "You have to configure the webhook URL in LINE application with the URL mentioned here."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram Channel",
        "DESC": "Integrate with Telegram channel and start supporting your customers.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Configure the bot token you have obtained from Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Create Telegram Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the telegram channel"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Phone calls",
        "DESC": "Setup which phone calls will show under this inbox.",
        "NAME": {
          "LABEL": "Inbox name",
          "SUBTITLE": "Pick an easily identifiable name."
        },
        "PHONE_NUMBER": {
          "LABEL": "Phone number",
          "SUBTITLE": "Enter phone numbers that belong to this inbox, you can add more numbers later.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Create Phone calls inbox",
        "API": {
          "ERROR_MESSAGE": "We were not able to create the inbox"
        }
      },
      "AUTH": {
        "TITLE": "Choose a channel",
        "DESC": "Chat supports live-chat widgets, Facebook Messenger, WhatsApp, Emails, etc., as channels. If you want to build a custom channel, you can create it using the API channel. To get started, choose one of the channels below."
      },
      "AGENTS": {
        "TITLE": "Agents",
        "DESC": "Here you can add agents to manage your newly created inbox. Only these selected agents will have access to your inbox. Agents which are not part of this inbox will not be able to see or respond to messages in this inbox when they login. <br> <b>PS:</b> As an administrator, if you need access to all inboxes, you should add yourself as agent to all inboxes that you create.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Pick agents for the inbox"
      },
      "DETAILS": {
        "TITLE": "Inbox Details",
        "DESC": "From the dropdown below, select the Facebook Page you want to connect to chat. You can also give a custom name to your inbox for better identification."
      },
      "FINISH": {
        "TITLE": "Nailed It!",
        "DESC": "You have successfully finished integrating your Facebook Page with chat. Next time a customer messages your Page, the conversation will automatically appear on your inbox.<br>We are also providing you with a widget script that you can easily add to your website. Once this is live on your website, customers can message you right from your website without the help of any external tool and the conversation will appear right here, on chat.<br>Cool, huh? Well, we sure try to be :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Authenticating you with Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Something went wrong, Please refresh page...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "We were unable to create the inbox. Please try again.",
      "CREATING_CHANNEL": "Creating your Inbox...",
      "TITLE": "Configure Inbox Details",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Add agents",
      "ADD_AGENTS": "Adding Agents to your Inbox..."
    },
    "FINISH": {
      "TITLE": "Your Inbox is ready!",
      "MESSAGE": "You can now engage with your customers through your new Channel. Happy supporting",
      "BUTTON_TEXT": "Take me there",
      "MORE_SETTINGS": "More settings",
      "WEBSITE_SUCCESS": "You have successfully finished creating a website channel. Copy the code shown below and paste it on your website. Next time a customer use the live chat, the conversation will automatically appear on your inbox."
    },
    "REAUTH": "Reauthorize",
    "VIEW": "View",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Inbox settings updated successfully",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Auto assignment updated successfully",
        "ERROR_MESSAGE": "We couldn't update inbox settings. Please try again later."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "from",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Save"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "None"
      },
      "SHOW_WELCOME_SCREEN": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "ENABLE_HMAC": {
        "LABEL": "Enable"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Enable synchronization of incoming emails"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Enable Custom Email Domain (paid service)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Enable Facebook comments processing"
      },
      "SIGNATURE": {
        "TITLE": "HTML Signature",
        "SUB_TEXT": "This signature will be added to the footer of every message sent from this inbox.",
        "HTML_CONTENT": "HTML code",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} will be replaced with the name of the agent.\n{'{{'}email{'}}'} will be replaced with the email address of the agent who sent the email.\n{'{{'}position{'}}'} will be replaced with the position of the agent.\n{'{{'}custom_line{'}}'} will be replaced with the custom line of the agent.\n{'{{'}email_signature_picture{'}}'} will be replaced with the URL of the agent's email signature picture (not an image tag) — use it as an image source (the src of an img tag).",
        "PREVIEW": "Preview"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Signatures by country",
        "SUB_TEXT": "A reply gets the signature of the buyer's country.",
        "HELP": "A reply is signed in the country of its conversation: the Kaufland storefront, the marketplace of the Allegro order, or else the language the buyer writes in. When the country is unknown or has no signature here, the HTML signature above is used. Marketplaces forbid links to your website and contact details, so keep it to a greeting and {'{{'}name{'}}'}.",
        "EMPTY": "You have no country signatures yet, so replies use the HTML signature above.",
        "COUNTRY": "Select a country",
        "ADD": "Add a country signature",
        "REMOVE": "Remove"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Phone Number Dialing Prefix",
        "PLACEHOLDER": "Enter prefix for correct call routing (e.g., *99)",
        "HELP_TEXT": "This prefix will be automatically prepended to contact phone numbers when dialing from this inbox."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Resolve later button text",
        "PLACEHOLDER": "e.g. We'll resolve this topic via email. I want to ask about something else now.",
        "HELP_TEXT": "Label of the widget button that lets the visitor leave the current topic and ask about something else. Leave empty to use the default text in the visitor's language."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Auto-snooze missed calls for X minutes",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Automatically snooze missed calls for specified number of minutes. Leave empty or 0 to disable."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Resolve a missed call after X failed callbacks",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Once a missed call has been called back X times without the customer answering, it is resolved automatically and a private note is added. Leave empty or 0 to disable."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Question Suggestions",
        "SUB_TEXT": "Configure predefined questions that customers can use to interact with your agents.",
        "QUESTIONS_LABEL": "Questions",
        "ADD_QUESTION": "Add Question",
        "QUESTION": "Question",
        "REMOVE": "Remove",
        "QUESTION_TEXT": "Text displayed in the bubble.",
        "QUESTION_TEXT_PLACEHOLDER": "Required",
        "QUESTION_PAYLOAD": "Text sent when clicked.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Optional",
        "SAVE": "Save",
        "NO_BOT_MESSAGE": "To generate additional AI suggestions, please connect a bot.",
        "BOT_CONNECTED_MESSAGE": "AI question suggestions from the bot can be activated in its",
        "BOT_SETTINGS_LINK": "settings"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Alternative Emails",
        "SUB_TEXT": "Additional addresses that this inbox should treat as its own when receiving forwarded mail.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Add",
        "REMOVE": "Remove",
        "EMPTY": "No alternative emails configured.",
        "HELP_TEXT": "When an email arrives with one of these addresses as the recipient, replies will be sent with the same address as the sender. Make sure your outgoing SMTP server allows sending from these addresses.",
        "SIGNATURE_LABEL": "Signature",
        "PRIMARY_SIGNATURE": "Primary (default)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Additional Signatures",
        "SUB_TEXT": "Define extra signatures here, then assign them to the alternative emails below.",
        "OPTION": "Signature {number}",
        "ADD": "Add signature",
        "REMOVE": "Remove",
        "HELP_TEXT": "When a reply is sent from an alternative email, its assigned signature is used instead of the inbox signature. Alternative emails left on \"Primary (default)\" fall back to the inbox signature."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Delete",
      "AVATAR_DELETE_BUTTON_TEXT": "Delete Avatar",
      "DELETE_REQUESTED_TOOLTIP": "This inbox is marked for deletion",
      "RESTORE_BUTTON_TEXT": "Restore",
      "CONFIRM": {
        "TITLE": "Confirm Deletion",
        "MESSAGE": "Are you sure to delete ",
        "PLACE_HOLDER": "Please type {inboxName} to confirm",
        "YES": "Yes, Delete ",
        "NO": "No, Keep "
      },
      "API": {
        "SUCCESS_MESSAGE": "Inbox deleted successfully",
        "MARKED_FOR_DELETION_MESSAGE": "Inbox marked for deletion",
        "RESTORE_SUCCESS_MESSAGE": "Inbox restored successfully",
        "ERROR_MESSAGE": "Could not delete inbox. Please try again later.",
        "RESTORE_ERROR_MESSAGE": "Could not restore inbox. Please try again later.",
        "AVATAR_SUCCESS_MESSAGE": "Inbox avatar deleted successfully",
        "AVATAR_ERROR_MESSAGE": "Could not delete the inbox avatar. Please try again later."
      }
    },
    "TABS": {
      "SETTINGS": "Settings",
      "COLLABORATORS": "Collaborators",
      "AUTOMATIC_PRIORITY": "Automatic Priority",
      "AUTOMATIC_LABELING": "Automatic Labeling",
      "CONFIGURATION": "Configuration",
      "CAMPAIGN": "Campaigns",
      "PRE_CHAT_FORM": "Pre Chat Form",
      "BUSINESS_HOURS": "Business Hours",
      "WIDGET_BUILDER": "Widget Builder",
      "BOT_CONFIGURATION": "Bot Configuration",
      "SLA": "SLA"
    },
    "SETTINGS": "Settings",
    "FEATURES": {
      "LABEL": "Features",
      "DISPLAY_FILE_PICKER": "Display file picker on the widget",
      "DISPLAY_EMOJI_PICKER": "Display emoji picker on the widget",
      "ALLOW_END_CONVERSATION": "Allow users to end conversation from the widget",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Display the 'start a new conversation' button in the widget header",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Hide input field when start new conversation button is shown",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot",
      "ALLOW_OFFLINE_REPLY": "Allow agents to send messages when contact is offline and email continuity is not available",
      "SHOW_HANDOFF_BUTTON": "Display the 'transfer to operator' button in the widget header",
      "AUTO_CLOSE_OLD": "Mark all past calls from the same number as resolved after one is resolved",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Automatically assign missed calls when making an outgoing call"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Web-widget Script",
      "MESSENGER_SUB_HEAD": "Place this button inside your body tag",
      "INBOX_AGENTS": "Agents",
      "INBOX_TEAMS": "Teams",
      "INBOX_COOPERATORS": "Cooperators",
      "SELECT_PLACEHOLDER": "Select",
      "AGENTS_OR_TEAMS_INFO": "You can assign either agents or teams - not both simultaneously.",
      "AGENT_ASSIGNMENT": "Conversation Assignment",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Update conversation assignment settings",
      "UPDATE": "Update",
      "ENABLE_EMAIL_COLLECT_BOX": "Enable email collect box",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Enable or disable email collect box on new conversation",
      "AUTO_ASSIGNMENT": "Enable auto assignment",
      "ENABLE_CSAT": "Enable CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Enable CSAT on each message",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "ENABLE_CSAT_SUB_TEXT": "Enable/Disable CSAT(Customer satisfaction) survey after resolving a conversation",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Enable/Disable CSAT survey option for each message sent by agents",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Enable conversation continuity via email",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Conversations will continue over email if the contact email address is available.",
      "RESPOND_FROM_EMAIL": "Respond from email",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Emails to the customer — both replies and conversation transcripts — are sent using the SMTP settings of the selected email inbox, from the selected address (the inbox's own address or one of its aliases), and the customer's replies arrive back through its IMAP address.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Conversation transcripts are sent using the SMTP settings of the selected email inbox, from the selected address (the inbox's own address or one of its aliases), with replies arriving back through its IMAP address.",
      "SHOW_WELCOME_SCREEN": "Show welcome screen",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Show the welcome screen when the widget is opened. If disabled, the widget will go directly to the conversation view.",
      "AUTO_CLOSE_PENDING": "Auto resolve AI chats after (hours)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Auto resolve AI chats after X hours of inactivity.",
      "LOCK_TO_SINGLE_CONVERSATION": "Lock to single conversation",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Enable or disable multiple conversations for the same contact in this inbox",
      "INBOX_UPDATE_TITLE": "Inbox Settings",
      "INBOX_UPDATE_SUB_TEXT": "Update your inbox settings",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Enable or disable the automatic assignment of new conversations to the agents added to this inbox.",
      "HMAC_VERIFICATION": "User Identity Validation",
      "HMAC_DESCRIPTION": "With this key you can generate a secret token that can be used to verify the identity of your users.",
      "HMAC_ROTATE": {
        "BUTTON": "Rotate key",
        "TITLE": "Rotate secret key?",
        "WARNING": "The current key is revoked the instant you rotate it.",
        "WARNING_DETAIL": "There is no overlap period and it cannot be restored.",
        "IMPACT": "Your servers must sign users with the new key. Anyone still signed with the old one fails verification. If identity validation is required, they cannot start a conversation.",
        "CONFIRM": "Rotate key",
        "CANCEL": "Cancel",
        "SUCCESS": "Secret key rotated successfully",
        "ERROR": "Could not rotate the secret key, please try again"
      },
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Enforce User Identity Validation",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests that cannot be verified will be rejected.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Force new conversation on every widget load",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "If enabled, opening the widget in a new tab or window starts a new conversation.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Forget the contact when a new conversation is started",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "When disabled, a new conversation started from the widget keeps the previous contact.",
      "INBOX_IDENTIFIER": "Inbox Identifier",
      "INBOX_IDENTIFIER_SUB_TEXT": "Use the `inbox_identifier` token shown here to authentication your API clients.",
      "FORWARD_EMAIL_TITLE": "Forward to Email",
      "FORWARD_EMAIL_SUB_TEXT": "Start forwarding your emails to the following email address.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Email Synchronization",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Enable automatic synchronization and downloading of incoming emails from this inbox",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Custom Email Domain",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Enable to use a custom email domain for outgoing emails",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "You can read more here.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook Comments",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Allow messages after conversation resolved",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Allow the end-users to send messages even after the conversation is resolved.",
      "WIDGET_STATUS_LABEL": "Widget Status",
      "WIDGET_STATUS_ENABLED": "Enabled",
      "WIDGET_STATUS_BUSINESS_HOURS": "Enabled during business hours",
      "WIDGET_STATUS_DISABLED": "Disabled",
      "WIDGET_STATUS_HELP_TEXT": "Control when the widget is shown to visitors on your website",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings",
      "EXPLICIT_CSAT_LOCALE": "CSAT survey and Email Locale",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Choose the language for all customer emails including CSAT surveys, conversation transcripts, and email notifications",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Inherit from account",
      "WHATSAPP_CONNECTION": {
        "TITLE": "WhatsApp connection",
        "SUBTITLE": "How this inbox is connected to WhatsApp.",
        "PROVIDER": "Provider",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Connected through Meta embedded signup",
        "STATUS": "Status",
        "CONNECTED": "Connected",
        "RECONNECT_HINT": "Click Reconnect in the banner above.",
        "PHONE_NUMBER": "Phone number",
        "BUSINESS_ACCOUNT": "WhatsApp Business Account ID",
        "OPEN_MANAGER": "Open in WhatsApp Manager",
        "PHONE_NUMBER_ID": "Phone number ID",
        "TEMPLATES": "Message templates",
        "TEMPLATES_COUNT": "{approved} of {total} approved",
        "TEMPLATES_SYNCED": "Last synced {date}",
        "TEMPLATES_NOT_SYNCED": "Not synced yet",
        "MANAGE_TEMPLATES": "Manage templates"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Auto assignment limit",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Please enter a value greater than 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limit the maximum number of conversations from this inbox that can be auto assigned to an agent"
    },
    "SLA": {
      "TITLE": "SLA Policies",
      "SUB_TEXT": "Configure SLA response and resolution times for each conversation priority level.",
      "LOADING": "Loading SLA policies...",
      "FIELDS": {
        "ACTIVE": "Active",
        "TICKET_PRIORITY": "Ticket priority",
        "FIRST_RESPONSE_TIME": "First response time",
        "EVERY_RESPONSE_TIME": "Every response time",
        "RESOLUTION_TIME": "Resolution time",
        "PLACEHOLDER": "e.g. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA policies updated successfully.",
        "ERROR_MESSAGE": "Could not update SLA policies. Please try again."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Automatic Priority",
      "SUB_TEXT": "Configure automatic priority assignment based on conversation content.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Billing Notice",
        "MESSAGE": "Every priority evaluation will incur a charge. Please review your plan details for pricing information."
      },
      "MODE": {
        "OFF": "Off",
        "ALL_MESSAGES": "On for all inbound messages",
        "FIRST_MESSAGE": "On for first inbound message only"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Priority Level Configuration",
        "SUB_TEXT": "Configure which priority levels should be enabled and their descriptions. Provide clear criteria for AI to determine when this priority should be assigned."
      },
      "DESCRIPTION_LABEL": "Description",
      "DESCRIPTION_PLACEHOLDER": "Describe conversations to be marked as {priority} priority",
      "SET_AS_DEFAULT": "Set as default priority",
      "MULTIPLE_DEFAULTS_WARNING": "Only one priority level should be set as default. Please uncheck other defaults."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Automatic Labeling",
      "SUB_TEXT": "Configure automatic label assignment based on conversation content.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Billing Notice",
        "MESSAGE": "Every labeling evaluation will incur a charge. Please review your plan details for pricing information."
      },
      "MODE": {
        "OFF": "Off",
        "CONVERSATION_OPEN": "On conversation open",
        "CONVERSATION_CLOSE": "On conversation close",
        "ALL_MESSAGES": "On every message - regardless of state",
        "FIRST_MESSAGE": "On first message - regardless of state"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Label Configuration",
        "SUB_TEXT": "Configure which labels should be available for automatic assignment and their descriptions. Provide clear criteria for AI to determine when this label should be applied."
      },
      "DESCRIPTION_LABEL": "Description",
      "DESCRIPTION_PLACEHOLDER": "Describe conversations to be labeled as {label}. If you leave this empty, the label description will be used.",
      "NO_LABELS_MESSAGE": "No labels found. Create labels first to enable automatic labeling.",
      "CREATE_LABELS_LINK": "Create labels"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Reauthorize",
      "SUBTITLE": "Your Facebook connection has expired, please reconnect your Facebook page to continue services",
      "MESSAGE_SUCCESS": "Reconnection successful",
      "MESSAGE_ERROR": "There was an error, please try again",
      "PAGE_NOT_GRANTED": "Facebook did not give access to this page. Reconnect with a Facebook account that has full control of the page and select the page in the Facebook dialog."
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Pre chat forms enable you to capture user information before they start conversation with you.",
      "SET_FIELDS": "Pre chat form fields",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Fields",
        "LABEL": "Label",
        "PLACE_HOLDER": "Placeholder",
        "KEY": "Key",
        "TYPE": "Type",
        "REQUIRED": "Required"
      },
      "ENABLE": {
        "LABEL": "Enable pre chat form",
        "OPTIONS": {
          "ENABLED": "Yes",
          "DISABLED": "No"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pre chat message",
        "PLACEHOLDER": "This message would be visible to the users along with the form"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Visitors should provide their name and email address before starting the chat"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Set your availability",
      "SUBTITLE": "Set your availability on your livechat widget",
      "WEEKLY_TITLE": "Set your weekly hours",
      "TIMEZONE_LABEL": "Select timezone",
      "UPDATE": "Update business hours settings",
      "TOGGLE_AVAILABILITY": "Enable business availability for this inbox",
      "UNAVAILABLE_MESSAGE_LABEL": "Unavailable message for visitors",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "ENABLE": "Enable availability for this day",
        "UNAVAILABLE": "Unavailable",
        "HOURS": "hours",
        "VALIDATION_ERROR": "Starting time should be before closing time.",
        "CHOOSE": "Choose"
      },
      "ALL_DAY": "All-Day",
      "SAVE_TO_ALL": "Save to All Inboxes",
      "SAVE_TO_ALL_TITLE": "Copy Working Hours",
      "SAVE_TO_ALL_CONFIRM": "The settings from this form (availability toggle, out-of-office message, timezone and working hours) will be copied to all other inboxes except email and phone inboxes. Are you sure you want to continue?",
      "SAVE_TO_ALL_CANCEL": "Cancel",
      "SAVE_TO_ALL_YES": "Yes, Copy to All",
      "SAVE_TO_ALL_SUCCESS": "Working hours copied to all other inboxes successfully",
      "SAVE_TO_ALL_ERROR": "Failed to copy working hours to other inboxes"
    },
    "PHONE": {
      "TITLE": "Phone settings",
      "SUBTITLE": "Configure what calls will show up under this inbox.",
      "UPDATE": "Save settings",
      "EDIT": {
        "SUCCESS_MESSAGE": "Phone settings updates",
        "ERROR_MESSAGE": "Failed to update phone settings"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Phone numbers",
        "SUBTITLE": "Enter phone numbers that belong to this inbox.",
        "PLACEHOLDER": "+145123908635",
        "ADD": "Add a phone number"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Set your IMAP details",
      "NOTE_TEXT": "To enable SMTP, please configure IMAP.",
      "UPDATE": "Update IMAP settings",
      "TOGGLE_AVAILABILITY": "Enable IMAP configuration for this inbox",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update IMAP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Login",
        "PLACE_HOLDER": "Login"
      },
      "PASSWORD": {
        "LABEL": "Password",
        "PLACE_HOLDER": "Password"
      },
      "ENABLE_SSL": "Enable SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Set your SMTP details",
      "UPDATE": "Update SMTP settings",
      "TOGGLE_AVAILABILITY": "Enable SMTP configuration for this inbox",
      "TOGGLE_HELP": "Enabling SMTP will help the user to send email",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update SMTP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Login",
        "PLACE_HOLDER": "Login"
      },
      "PASSWORD": {
        "LABEL": "Password",
        "PLACE_HOLDER": "Password"
      },
      "DOMAIN": {
        "LABEL": "Domain",
        "PLACE_HOLDER": "Domain"
      },
      "ENCRYPTION": "Encryption",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL Verify Mode",
      "AUTH_MECHANISM": "Authentication"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Email deliverability (DNS)",
      "SUB_TITLE": "We check the SPF, DKIM, DMARC and MX records of {domain} every working day. When something makes receiving servers reject or junk your replies, administrators get an email with the fix.",
      "RUN": "Run check",
      "RUN_SUCCESS": "DNS check finished",
      "RUN_ERROR": "Could not run the DNS check, please try again",
      "NOT_CHECKED": "Not checked yet.",
      "CHECKED_AT": "Last checked {time}.",
      "DNS_UNAVAILABLE": "The last check got no answer from the domain's name servers. The result below is from the check before.",
      "SENDER": {
        "SMTP": "Replies are sent through {host}.",
        "PLATFORM": "Replies are sent through our mail servers."
      },
      "STATUS": {
        "OK": "All records are in order",
        "WARNING": "Some records could be better",
        "ERROR": "Replies may not reach recipients",
        "UNKNOWN": "Unknown"
      },
      "SEVERITY": {
        "ERROR": "Problem",
        "WARNING": "Warning"
      },
      "FIX": "Fix it with this DNS record:",
      "RECORD_TYPE": "Type",
      "RECORD_HOST": "Name",
      "RECORD_VALUE": "Value",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "SPF record is missing",
          "DESCRIPTION": "The domain does not say which servers may send its email. Many mail servers then treat your replies as spam. Add an SPF record that allows {sender}."
        },
        "spf_multiple": {
          "TITLE": "The domain has {count} SPF records",
          "DESCRIPTION": "A domain may have only one SPF record. With more, receiving servers ignore SPF and often reject the mail. Merge them into one record."
        },
        "spf_not_authorized": {
          "TITLE": "SPF does not allow the server that sends your replies",
          "DESCRIPTION": "Your replies are sent through {sender}, but the SPF record of the domain does not list it. Current record: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "SPF record needs too many DNS lookups",
          "DESCRIPTION": "Receiving servers stop checking SPF after {limit} DNS lookups, but {sender}, which sends your replies, is only reached after {lookups}. Your replies fail SPF. Move {sender} to the start of the record and remove includes the domain no longer uses."
        },
        "spf_lookups_others": {
          "TITLE": "Some senders in the SPF record are past the lookup limit",
          "DESCRIPTION": "The SPF record needs {lookups} DNS lookups, receiving servers stop after {limit}. Your replies are matched in time and pass, but mail from these senders fails SPF: {senders}. Remove includes the domain no longer uses."
        },
        "spf_malformed": {
          "TITLE": "SPF record is broken",
          "DESCRIPTION": "Receiving servers cannot read the SPF record of the domain, so it does not protect your replies. The problem is in: {terms}. Replace the record with the corrected one."
        },
        "dkim_missing": {
          "TITLE": "DKIM signature is not set up",
          "DESCRIPTION": "We found no DKIM key at {selectors}. Without it your replies are not signed and are more likely to end up in spam. Turn on DKIM signing for the domain with your email provider."
        },
        "dmarc_missing": {
          "TITLE": "DMARC record is missing",
          "DESCRIPTION": "Large mail providers such as Gmail and Microsoft expect a DMARC record. Without it your replies are more likely to end up in spam."
        },
        "dmarc_fails": {
          "TITLE": "DMARC tells receivers to reject your replies",
          "DESCRIPTION": "The DMARC policy of the domain is \"{policy}\" and your replies pass neither SPF nor DKIM, so receivers reject them or move them to spam. Fix SPF and DKIM above."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC blocks replies sent through our mail servers",
          "DESCRIPTION": "This inbox sends replies through our mail servers, but the DMARC policy of the domain is \"{policy}\", so receivers reject them or move them to spam. Set up SMTP of your own mail server for this inbox."
        },
        "mx_missing": {
          "TITLE": "The domain has no MX record",
          "DESCRIPTION": "Without an MX record nobody can send email to the domain, so customers cannot answer your replies."
        }
      }
    },
    "NOTE": "Note: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Website Avatar",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar deleted successfully",
              "ERROR_MESSAGE": "There was an error, please try again"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Website Name",
          "PLACE_HOLDER": "Enter your website name (eg: Acme Inc)",
          "ERROR": "Please enter a valid website name"
        },
        "WELCOME_HEADING": {
          "LABEL": "Welcome Heading",
          "PLACE_HOLDER": "Hi there!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Welcome Tagline",
          "PLACE_HOLDER": "We make it simple to connect with us. Ask us anything, or share your feedback."
        },
        "REPLY_TIME": {
          "LABEL": "Reply Time",
          "IN_A_FEW_MINUTES": "In a few minutes",
          "IN_A_FEW_HOURS": "In a few hours",
          "IN_A_DAY": "In a day"
        },
        "WIDGET_COLOR_LABEL": "Widget Color",
        "WIDGET_BUBBLE_POSITION_LABEL": "Widget Bubble Position",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Unread Messages Max Height (px)",
          "PLACE_HOLDER": "No limit",
          "HELP_TEXT": "Limit the maximum height of the unread messages popup in pixels. Leave empty for the default behaviour (no limit)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Widget Bubble Type",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Chat with us",
          "LABEL": "Widget Bubble Launcher Title",
          "PLACE_HOLDER": "Chat with us"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Update Widget Settings",
          "API": {
            "SUCCESS_MESSAGE": "Widget settings updated successfully",
            "ERROR_MESSAGE": "Unable to update widget settings"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Preview",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Left",
          "RIGHT": "Right"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Expanded Bubble"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Default",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Typically replies in a few minutes",
        "IN_A_FEW_HOURS": "Typically replies in a few hours",
        "IN_A_DAY": "Typically replies in a day"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Start Conversation",
        "CHAT_INPUT_PLACEHOLDER": "Type your message"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "We are Online",
          "OFFLINE": "We are away at the moment"
        },
        "USER_MESSAGE": "Hi",
        "AGENT_MESSAGE": "Hello"
      },
      "BRANDING_TEXT": "Powered by JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Other Providers"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Website",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "Email",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API Channel",
      "PHONE": "SIP Phone",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
